import {
	SET_ERROR,
	CORE_AUTH_VERIFY_SUCCESS,
	CORE_AUTH_VERIFY_FAILURE,

	CORE_GET_USERS_REQUEST,
	CORE_GET_USERS_SUCCESS,
	CORE_GET_USERS_FAILURE,

	CORE_GET_MASTERS_REQUEST,
	CORE_GET_MASTERS_SUCCESS,
	CORE_GET_MASTERS_FAILURE,

	CORE_GET_COURSE_BY_ID_INCOMING_REQUEST,
	CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS,
	CORE_GET_COURSE_BY_ID_INCOMING_FAILURE,


} from '../types'

import {

	CORE_GET_ALL_HR_SALARY_REQUEST,
	CORE_GET_ALL_HR_SALARY_SUCCESS,
	CORE_GET_ALL_HR_SALARY_FAILURE,

	CORE_GET_MASTER_HR_SALARY_BY_ID_REQUEST,
	CORE_GET_MASTER_HR_SALARY_BY_ID_SUCCESS,
	CORE_GET_MASTER_HR_SALARY_BY_ID_FAILURE,

	CORE_CREATE_HR_SALARY_REQUEST,
	CORE_CREATE_HR_SALARY_SUCCESS,
	CORE_CREATE_HR_SALARY_FAILURE,

	CORE_UPDATE_HR_SALARY_REQUEST,
	CORE_UPDATE_HR_SALARY_SUCCESS,
	CORE_UPDATE_HR_SALARY_FAILURE,

	CORE_CANCEL_HR_SALARY_REQUEST,
	CORE_CANCEL_HR_SALARY_SUCCESS,
	CORE_CANCEL_HR_SALARY_FAILURE,

	CORE_ACKNOWLEDGE_HR_SALARY_REQUEST,
	CORE_ACKNOWLEDGE_HR_SALARY_SUCCESS,
	CORE_ACKNOWLEDGE_HR_SALARY_FAILURE,

	CORE_ACCEPT_HR_SALARY_REQUEST,
	CORE_ACCEPT_HR_SALARY_SUCCESS,
	CORE_ACCEPT_HR_SALARY_FAILURE,

	CORE_REPORT_HR_SALARY_REQUEST,
	CORE_REPORT_HR_SALARY_SUCCESS,
	CORE_REPORT_HR_SALARY_FAILURE,


	CORE_REJECT_HR_SALARY_REQUEST,
	CORE_REJECT_HR_SALARY_SUCCESS,
	CORE_REJECT_HR_SALARY_FAILURE,

	CORE_COMPLETE_HR_SALARY_REQUEST,
	CORE_COMPLETE_HR_SALARY_SUCCESS,
	CORE_COMPLETE_HR_SALARY_FAILURE,

	CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_REQUEST,
	CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_SUCCESS,
	CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_FAILURE,

	CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_REQUEST,
	CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_SUCCESS,
	CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_FAILURE,

	CORE_CREATE_REQ_MASTER_REPORT_TYPE_REQUEST,
	CORE_CREATE_REQ_MASTER_REPORT_TYPE_SUCCESS,
	CORE_CREATE_REQ_MASTER_REPORT_TYPE_FAILURE,

	CORE_UPDATE_REQ_MASTER_REPORT_TYPE_REQUEST,
	CORE_UPDATE_REQ_MASTER_REPORT_TYPE_SUCCESS,
	CORE_UPDATE_REQ_MASTER_REPORT_TYPE_FAILURE,

	CORE_DELETE_REQ_MASTER_REPORT_TYPE_REQUEST,
	CORE_DELETE_REQ_MASTER_REPORT_TYPE_SUCCESS,
	CORE_DELETE_REQ_MASTER_REPORT_TYPE_FAILURE,

	CORE_GET_ALL_MASTER_HR_SALARY_REQUEST,
	CORE_GET_ALL_MASTER_HR_SALARY_SUCCESS,
	CORE_GET_ALL_MASTER_HR_SALARY_FAILURE,





} from '../masterDataTypes'

import {
	CORE_GET_ALL_FLOW_REQUEST,
	CORE_GET_ALL_FLOW_SUCCESS,
	CORE_GET_ALL_FLOW_FAILURE,

	CORE_GET_FLOW_BY_ID_REQUEST,
	CORE_GET_FLOW_BY_ID_SUCCESS,
	CORE_GET_FLOW_BY_ID_FAILURE,

	CORE_CREATE_FLOW_REQUEST,
	CORE_CREATE_FLOW_SUCCESS,
	CORE_CREATE_FLOW_FAILURE,

	CORE_UPDATE_FLOW_REQUEST,
	CORE_UPDATE_FLOW_SUCCESS,
	CORE_UPDATE_FLOW_FAILURE,

	CORE_GET_ALL_USER_GROUP_REQUEST,
	CORE_GET_ALL_USER_GROUP_SUCCESS,
	CORE_GET_ALL_USER_GROUP_FAILURE,

	CORE_GET_USER_GROUP_BY_ID_REQUEST,
	CORE_GET_USER_GROUP_BY_ID_SUCCESS,
	CORE_GET_USER_GROUP_BY_ID_FAILURE,

	CORE_CREATE_USER_GROUP_REQUEST,
	CORE_CREATE_USER_GROUP_SUCCESS,
	CORE_CREATE_USER_GROUP_FAILURE,

	CORE_UPDATE_USER_GROUP_REQUEST,
	CORE_UPDATE_USER_GROUP_SUCCESS,
	CORE_UPDATE_USER_GROUP_FAILURE,

} from '../settingsType'



const initialStateCallAPI = {
	isLoading: false,

	hasError: false,
	errorMessage: '',
	errorCode: '',
	statusText: ''
}
	, initialStateArray = []


export default {
	errorList: (state = initialStateArray, action) => {
		switch (action.type) {
			case SET_ERROR:
				let newError = []
				if (action && Array.isArray(action.error)) {
					newError = action.error
				}
				return newError
			case CORE_AUTH_VERIFY_SUCCESS:
			case CORE_GET_MASTERS_SUCCESS:
			case CORE_GET_ALL_FLOW_SUCCESS:
			case CORE_GET_FLOW_BY_ID_SUCCESS:
			case CORE_CREATE_FLOW_SUCCESS:
			case CORE_UPDATE_FLOW_SUCCESS:
			case CORE_GET_ALL_USER_GROUP_SUCCESS:
			case CORE_GET_USER_GROUP_BY_ID_SUCCESS:
			case CORE_CREATE_USER_GROUP_SUCCESS:
			case CORE_UPDATE_USER_GROUP_SUCCESS:
			case CORE_GET_ALL_HR_SALARY_SUCCESS:
			case CORE_GET_MASTER_HR_SALARY_BY_ID_SUCCESS:
			case CORE_CREATE_HR_SALARY_SUCCESS:
			case CORE_UPDATE_HR_SALARY_SUCCESS:
			case CORE_CANCEL_HR_SALARY_SUCCESS:
			case CORE_ACKNOWLEDGE_HR_SALARY_SUCCESS:
			case CORE_ACCEPT_HR_SALARY_SUCCESS:
			case CORE_REPORT_HR_SALARY_SUCCESS:
			case CORE_REJECT_HR_SALARY_SUCCESS:
			case CORE_COMPLETE_HR_SALARY_SUCCESS:
				// if (action && typeof action.payload === 'object') {
				// 	let newError = []
				// 	newError.push({ code: "404", message: "test", isShow: true, isFromAction: true })
				// 	newError.push({ code: "404", message: "ระบบเป็นอะไรไม่รู้ บ้า เล่นอะไรไม่เอาไม่ดี", isShow: true, isFromAction: true })
				// 	newError.push({ code: "404", message: "ลองดูอีกทีได้ไหม เริ่มต้นอีกทีได้ไหม แล้วฉันจะเป็นอย่างไร ใครจะรู้", isShow: true, isFromAction: true })
				// 	newError.push({ code: "404", message: "ลองดูอีกทีได้ไหม เริ่มต้นอีกทีได้ไหม แล้วฉันจะเป็นอย่างไร ใครจะรู้", isShow: true, isFromAction: true })
				// 	newError.push({ code: "404", message: "ลองดูอีกทีได้ไหม เริ่มต้นอีกทีได้ไหม แล้วฉันจะเป็นอย่างไร ใครจะรู้", isShow: true, isFromAction: true })
				// 	return newError
				// }
				if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
					const { errors, result } = action.payload
					const { url } = action
					let newError = []
					if (!result) {
						if (Array.isArray(errors)) {
							errors.map(e => {
								const { path, code, message } = e
								return newError.push({ code, message, isShow: true, path, url, isFromAction: true })
							})
						}
						else if (errors && errors.axError) {
							if (Array.isArray(errors.errors)) {
								errors.errors.map(e => {
									const { path, message } = e
									return newError.push({ code: "Please Contact AX Admin", message, isShow: true, isAxError: true, path, url, isFromAction: true })
								})
							} else newError.push({ code: "Please Contact AX Admin", message: errors.errors, isShow: true, isAxError: true, path: "", url, isFromAction: true })
						}
						else newError.push({ code: "unknow", message: "Some thing went wrong", isShow: true, path: "", url, isFromAction: true })
					}
					console.log("newErroo", newError)
					return newError
				}
				return state
			case CORE_AUTH_VERIFY_FAILURE:
			case CORE_GET_MASTERS_FAILURE:
			case CORE_GET_ALL_FLOW_FAILURE:
			case CORE_GET_FLOW_BY_ID_FAILURE:
			case CORE_CREATE_FLOW_FAILURE:
			case CORE_UPDATE_FLOW_FAILURE:
			case CORE_GET_ALL_USER_GROUP_FAILURE:
			case CORE_GET_USER_GROUP_BY_ID_FAILURE:
			case CORE_CREATE_USER_GROUP_FAILURE:
			case CORE_UPDATE_USER_GROUP_FAILURE:
			case CORE_GET_ALL_HR_SALARY_FAILURE:
			case CORE_GET_MASTER_HR_SALARY_BY_ID_FAILURE:
			case CORE_CREATE_HR_SALARY_FAILURE:
			case CORE_UPDATE_HR_SALARY_FAILURE:
			case CORE_CANCEL_HR_SALARY_FAILURE:
			case CORE_ACKNOWLEDGE_HR_SALARY_FAILURE:
			case CORE_ACCEPT_HR_SALARY_FAILURE:
			case CORE_REPORT_HR_SALARY_FAILURE:
			case CORE_REJECT_HR_SALARY_FAILURE:
			case CORE_COMPLETE_HR_SALARY_FAILURE:
				if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
					const { code, message, statusText, statusCode } = action.payload
					console.log(action)
					const { url } = action
					let newError = []

					newError.push({
						code: code ? code : statusCode ? statusCode : "404",
						message: message ? message : statusText ? statusText : 'unknow',
						isShow: false,
						statusText,
						statusCode,
						url
					})

					return newError
				}
				return state
			default:
				return state
		}
	},
	isLoading: (state = false, action) => {
		switch (action.type) {
			// 	case CORE_GET_ALL_TRANSFERS_REQUEST:
			case CORE_GET_MASTERS_REQUEST:
			case CORE_GET_USERS_REQUEST:
			case CORE_GET_ALL_FLOW_REQUEST:
			case CORE_GET_FLOW_BY_ID_REQUEST:
			case CORE_CREATE_FLOW_REQUEST:
			case CORE_UPDATE_FLOW_REQUEST:
			case CORE_GET_ALL_USER_GROUP_REQUEST:
			case CORE_GET_USER_GROUP_BY_ID_REQUEST:
			case CORE_CREATE_USER_GROUP_REQUEST:
			case CORE_UPDATE_USER_GROUP_REQUEST:
			case CORE_GET_ALL_HR_SALARY_REQUEST:
			case CORE_GET_MASTER_HR_SALARY_BY_ID_REQUEST:
			case CORE_CREATE_HR_SALARY_REQUEST:
			case CORE_UPDATE_HR_SALARY_REQUEST:
			case CORE_CANCEL_HR_SALARY_REQUEST:
			case CORE_ACKNOWLEDGE_HR_SALARY_REQUEST:
			case CORE_ACCEPT_HR_SALARY_REQUEST:
			case CORE_REPORT_HR_SALARY_REQUEST:
			case CORE_REJECT_HR_SALARY_REQUEST:
			case CORE_COMPLETE_HR_SALARY_REQUEST:
			case CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_REQUEST:
			case CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_REQUEST:
			case CORE_CREATE_REQ_MASTER_REPORT_TYPE_REQUEST:
			case CORE_UPDATE_REQ_MASTER_REPORT_TYPE_REQUEST:
			case CORE_DELETE_REQ_MASTER_REPORT_TYPE_REQUEST:
			case CORE_GET_ALL_MASTER_HR_SALARY_REQUEST:
			case CORE_GET_COURSE_BY_ID_INCOMING_REQUEST:
				return true
			// 	case CORE_GET_ALL_TRANSFERS_SUCCESS:
			case CORE_GET_MASTERS_SUCCESS:
			case CORE_GET_USERS_SUCCESS:
			case CORE_GET_ALL_FLOW_SUCCESS:
			case CORE_GET_FLOW_BY_ID_SUCCESS:
			case CORE_CREATE_FLOW_SUCCESS:
			case CORE_UPDATE_FLOW_SUCCESS:
			case CORE_GET_ALL_USER_GROUP_SUCCESS:
			case CORE_GET_USER_GROUP_BY_ID_SUCCESS:
			case CORE_CREATE_USER_GROUP_SUCCESS:
			case CORE_UPDATE_USER_GROUP_SUCCESS:
			case CORE_GET_ALL_HR_SALARY_SUCCESS:
			case CORE_GET_MASTER_HR_SALARY_BY_ID_SUCCESS:
			case CORE_CREATE_HR_SALARY_SUCCESS:
			case CORE_UPDATE_HR_SALARY_SUCCESS:
			case CORE_CANCEL_HR_SALARY_SUCCESS:
			case CORE_ACKNOWLEDGE_HR_SALARY_SUCCESS:
			case CORE_ACCEPT_HR_SALARY_SUCCESS:
			case CORE_REPORT_HR_SALARY_SUCCESS:
			case CORE_REJECT_HR_SALARY_SUCCESS:
			case CORE_COMPLETE_HR_SALARY_SUCCESS:
			case CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_SUCCESS:
			case CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_SUCCESS:
			case CORE_CREATE_REQ_MASTER_REPORT_TYPE_SUCCESS:
			case CORE_UPDATE_REQ_MASTER_REPORT_TYPE_SUCCESS:
			case CORE_DELETE_REQ_MASTER_REPORT_TYPE_SUCCESS:
			case CORE_GET_ALL_MASTER_HR_SALARY_SUCCESS:
			case CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS:
				return false
			// 	case CORE_GET_ALL_TRANSFERS_FAILURE:
			case CORE_GET_MASTERS_FAILURE:
			case CORE_GET_USERS_FAILURE:
			case CORE_GET_ALL_FLOW_FAILURE:
			case CORE_GET_FLOW_BY_ID_FAILURE:
			case CORE_CREATE_FLOW_FAILURE:
			case CORE_UPDATE_FLOW_FAILURE:
			case CORE_GET_ALL_USER_GROUP_FAILURE:
			case CORE_GET_USER_GROUP_BY_ID_FAILURE:
			case CORE_CREATE_USER_GROUP_FAILURE:
			case CORE_UPDATE_USER_GROUP_FAILURE:
			case CORE_GET_ALL_HR_SALARY_FAILURE:
			case CORE_GET_MASTER_HR_SALARY_BY_ID_FAILURE:
			case CORE_CREATE_HR_SALARY_FAILURE:
			case CORE_UPDATE_HR_SALARY_FAILURE:
			case CORE_CANCEL_HR_SALARY_FAILURE:
			case CORE_ACKNOWLEDGE_HR_SALARY_FAILURE:
			case CORE_ACCEPT_HR_SALARY_FAILURE:
			case CORE_REPORT_HR_SALARY_FAILURE:
			case CORE_REJECT_HR_SALARY_FAILURE:
			case CORE_COMPLETE_HR_SALARY_FAILURE:
			case CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_FAILURE:
			case CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_FAILURE:
			case CORE_CREATE_REQ_MASTER_REPORT_TYPE_FAILURE:
			case CORE_UPDATE_REQ_MASTER_REPORT_TYPE_FAILURE:
			case CORE_DELETE_REQ_MASTER_REPORT_TYPE_FAILURE:
			case CORE_GET_ALL_MASTER_HR_SALARY_FAILURE:
			case CORE_GET_COURSE_BY_ID_INCOMING_FAILURE:
				return false
			default:
				return state
		}
	},
	reducerCallAPI: (state = initialStateCallAPI, action) => {
		switch (action.type) {

			default:
				return state
		}
	},

}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerCallAPI.js